export const samplePageSubTitle = [
    {
        text: 'Here you can enter a sub-title for your card.'
    }
];

export const samplePageData = [
    {
        id: 1,
        strongText: 'Web Design Trends: ',
        text: "Stay up-to-date with the latest trends in web design, such as the use of animations, micro-interactions, dark mode, and unique navigation techniques.Keep your website's navigation simple and intuitive, allowing users to find what they need easily without overwhelming them with options."
    },
    {
        id: 2,
        strongText: 'Design Tools: ',
        text: "Information on popular design software like Adobe Photoshop, Sketch, Figma, or Adobe XD, along with tips and tricks for efficient workflow and collaboration.Compress and optimize images to improve website loading speed and overall performance, providing a better user experience."
    },
    {
        id: 3,
        strongText: 'Front-End Development: ',
        text: "A basic understanding of HTML, CSS, and JavaScript can enhance your web design skills, enabling you to create interactive and dynamic elements.Ensure sufficient contrast between text and background colors to enhance readability and accessibility, especially for users with visual impairments."
    },
]